class MobileLeftMenu {
    constructor(selector) {
        if (!selector) return;
        
        this.body = document.querySelector("body");
        this.html = document.querySelector("html");
        this.menu = document.querySelector(selector);
        this.markIcon = 'fa-regular fa-xmark fa-flip-horizontal';
        this.hamburgerIcon = 'fa-regular fa-bars-staggered fa-flip-horizontal';

        if ( this.menu === null ){
            return;  
        }        
        this.menuContainer = this.menu.querySelector(".c-mobile-left-menu-container");
        this.menuButton = this.menu.querySelector(".c-icon-button");
        this.subMenus = this.menu.querySelectorAll(".activity-button-card-submenu");
        this.subMenuBackButtons = this.menu.querySelectorAll(".activity-button-card-submenu-subheader .c-icon-button");
        this.activityButtons = this.menuContainer.querySelectorAll(".c-activity-button-card");
        this.readMoreButtons = this.menu.querySelectorAll(".activity-button-card-submenu-read-more a");
        this.init();
    }

    init() {
        this.activityButtons.forEach(button => {
            button.addEventListener("click", (e) => {
                let currentSelectedID = button.getAttribute("data-id");
                this.subMenus.forEach(subMenu => {
                    if (subMenu.id === currentSelectedID) {
                        this.showSubMenu(subMenu);
                    }
                });
            });
        });

        this.readMoreButtons.forEach(button => {
            button.addEventListener("click", (e) => {
                const textButtonSpan = button.querySelector("span");
                const icon = button.querySelector("i");
                const siblings = button.parentElement.parentElement.querySelectorAll(".activity-button-card-submenu-link-container");

                siblings.forEach(sibling => {
                    if (sibling.classList.contains("hidden")) {
                        sibling.classList.remove("hidden");
                        sibling.classList.add("show");
                    } else if (sibling.classList.contains("show")) {
                        sibling.classList.remove("show");
                        sibling.classList.add("hidden");
                    }
                });
                
                // Button text toggle
                if (textButtonSpan.textContent.trim() === "See more") {
                    textButtonSpan.textContent = "See less";
                    icon.classList.remove("fa-chevron-down");
                    icon.classList.add("fa-chevron-up");                    
                } else {
                    textButtonSpan.textContent = "See more";
                    icon.classList.remove("fa-chevron-up");
                    icon.classList.add("fa-chevron-down");                    
                }

            });
        });

        this.subMenuBackButtons.forEach(button => {
            button.addEventListener("click", () => {
                this.hideAllSubMenus();
            });
        });

        this.menuButton.addEventListener("click", (e) => {
            e.stopPropagation();
            if ( $("body.id-7").length ){
                if (this.menuContainer.classList.contains("show")) {
                    this.hideMenu();
                } else {
                    this.showMenu();
                }
            }else{
                if ( $(".menu-nav").is(":visible") ){
                    $(this.menuButton).find("i").attr("class",this.hamburgerIcon);
                }else{
                    $(this.menuButton).find("i").attr("class",this.markIcon);
                }

                $(".menu-nav, .menu-nav .main-menu").slideToggle();
            }
        });

        document.addEventListener("click", (e) => {
            if (!this.menu.contains(e.target) && this.menuContainer.classList.contains("show")) {
                return; // Prevent hiding menu when clicking outside
            }
        });
    }

    showMenu() {
        let mainHeaderHeight = $("#main-header").height();
        if ( $("#wpadminbar").length ){
            mainHeaderHeight += $("#wpadminbar").height();
        }

        if ( $("#s-search-container-mobile-wrapper").is(":visible") ){
            mainHeaderHeight -= $("#s-search-container-mobile-wrapper").height();
        }

        $(this.menuContainer).css("margin-top", (mainHeaderHeight-1) + "px");
        this.menuContainer.classList.add("show");
        $(this.menuButton).find("i").attr("class",this.markIcon);
        this.body.classList.add("body-no-scroll");
        this.html.classList.add("html-modal-open");
    }

    hideMenu() {
        this.menuContainer.classList.remove("show");
        $(this.menuButton).find("i").attr("class",this.hamburgerIcon);
        this.hideAllSubMenus();
        this.body.classList.remove("body-no-scroll");
        this.html.classList.remove("html-modal-open");
    }

    showSubMenu(subMenu) {
        subMenu.style.display = "block";
    }

    hideAllSubMenus() {
        this.subMenus.forEach(subMenu => subMenu.style.display = "none");
    }
}